angular.module( 'acme.view.application.membership.benefits', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.benefits.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipBenefits = {
        name: 'application.membership.benefits',
        url: '/benefits',
        views: {
          "subview-main": {
            controller: 'MembershipBenefitsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/benefits/benefits.tpl.html'
          }
        },
        data: {
          pageTitle: 'Membership Benefits',
          /** Secure With Permissions **/
          permissions: ['MEMBERSHIP_VIEW']
        }
      };

    $stateProvider
      .state(membershipBenefits);
});
